// @ts-nocheck
(function () {
  if (window.__rarelyLpWaitlistLoaded) return;
  window.__rarelyLpWaitlistLoaded = true;

  var API_URL = 'https://rarely-demand-api.vercel.app/api/notify';
  var COUNT_URL = 'https://rarely-demand-api.vercel.app/api/count';
  var TURNSTILE_SITE_KEY = '0x4AAAAAADLfqk5hchJ05AF2';
  var SOLD_OUT_RE = /\b(sold\s*out|restocking|out\s*of\s*stock|unavailable|join\s*(the\s*)?waitlist|notify\s*me)\b/i;
  var uid = 0;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function parseRegistries() {
    var byHandle = Object.create(null);
    document.querySelectorAll('script[data-rarely-lp-waitlist-product]').forEach(function (node) {
      try {
        var data = JSON.parse(node.textContent || '{}');
        if (data && data.handle && !byHandle[data.handle]) byHandle[data.handle] = data;
      } catch (err) {
        console.warn('[Rarely waitlist] Invalid product registry', err);
      }
    });
    return Object.keys(byHandle).map(function (handle) { return byHandle[handle]; });
  }

  function normalizeProduct(product) {
    if (!product || !product.handle || !product.id) return null;
    var variants = Array.isArray(product.variants) ? product.variants : [];
    return {
      id: Number(product.id),
      handle: String(product.handle),
      title: String(product.title || product.handle),
      variants: variants.map(function (variant) {
        return {
          id: Number(variant.id),
          title: String(variant.title || 'Default Title'),
          available: Boolean(variant.available),
          preorder: Boolean(variant.preorder),
        };
      }).filter(function (variant) { return Boolean(variant.id); }),
    };
  }

  function hydrateProduct(entry) {
    var normalized = normalizeProduct(entry);
    if (normalized) return Promise.resolve(normalized);
    if (!entry || !entry.handle) return Promise.resolve(null);
    var productPath = '/products/' + encodeURIComponent(entry.handle);
    return fetch(productPath + '?view=rarely-waitlist-json', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.ok ? response.json().catch(function () { return null; }) : null;
      })
      .then(function (data) {
        var normalized = normalizeProduct(data);
        if (normalized) return normalized;
        return fetch(productPath + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then(function (fallback) { return fallback.ok ? fallback.json() : null; })
          .then(normalizeProduct);
      })
      .catch(function () { return null; });
  }

  function waitlistVariants(product) {
    return product.variants.filter(function (variant) {
      return !variant.available || variant.preorder;
    });
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function addFieldLabel(parent, text, forId) {
    var label = el('label', 'rarely-lp-waitlist__label', text);
    label.htmlFor = forId;
    parent.appendChild(label);
  }

  function createNotifyForm(product, variants) {
    uid += 1;
    var block = el('div', 'rarely-lp-waitlist__form-block');
    var selected = variants[0];

    if (variants.length > 1 || (variants[0] && variants[0].title !== 'Default Title')) {
      var variantField = el('div', 'rarely-lp-waitlist__field');
      var variantId = 'rarely-lp-waitlist-variant-' + uid;
      addFieldLabel(variantField, 'Choose the option you want', variantId);
      var variantSelect = el('select', 'rarely-lp-waitlist__select');
      variantSelect.id = variantId;
      variants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.title + (variant.preorder ? ' — available to pre-order' : ' — sold out');
        variantSelect.appendChild(option);
      });
      variantField.appendChild(variantSelect);
      block.appendChild(variantField);
    }

    var notify = document.createElement('demand-notify-form');
    notify.className = 'demand-soldout';
    notify.dataset.apiUrl = API_URL;
    notify.dataset.countUrl = COUNT_URL;
    notify.dataset.countThreshold = '5';
    notify.dataset.turnstileSiteKey = TURNSTILE_SITE_KEY;
    notify.dataset.productId = String(product.id);
    notify.dataset.productHandle = product.handle;
    notify.dataset.productTitle = product.title;
    notify.dataset.variantId = String(selected.id);
    notify.dataset.textSuccess = "You're on the list. We'll email you when it's back.";
    notify.dataset.textError = 'Something went wrong. Please try again.';
    notify.dataset.textInvalidEmail = 'Please enter a valid email address.';

    var count = el('p', 'demand-soldout__count');
    count.setAttribute('data-count', '');
    count.hidden = true;
    notify.appendChild(count);

    var form = el('form', 'demand-soldout__form');
    form.noValidate = true;
    var emailId = 'rarely-lp-waitlist-email-' + uid;
    var emailLabel = el('label', 'rarely-lp-waitlist__visually-hidden', 'Email address');
    emailLabel.htmlFor = emailId;
    var email = el('input', 'demand-soldout__input');
    email.id = emailId;
    email.type = 'email';
    email.name = 'email';
    email.required = true;
    email.autocomplete = 'email';
    email.placeholder = 'you@example.com';
    var submit = el('button', 'demand-soldout__submit', 'Notify me');
    submit.type = 'submit';
    form.appendChild(emailLabel);
    form.appendChild(email);
    form.appendChild(submit);
    notify.appendChild(form);

    var status = el('div', 'demand-soldout__status');
    status.setAttribute('data-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    notify.appendChild(status);

    var turnstile = el('div', 'cf-turnstile demand-soldout__turnstile');
    turnstile.dataset.sitekey = TURNSTILE_SITE_KEY;
    turnstile.dataset.size = 'invisible';
    notify.appendChild(turnstile);
    block.appendChild(notify);

    var select = block.querySelector('.rarely-lp-waitlist__select');
    if (select) {
      select.addEventListener('change', function () {
        notify.dataset.variantId = select.value;
      });
    }
    return block;
  }

  function cardShell(title, copy) {
    var section = el('section', 'rarely-lp-waitlist');
    section.setAttribute('aria-label', 'Back-in-stock notifications');
    var card = el('div', 'rarely-lp-waitlist__card');
    card.appendChild(el('p', 'rarely-lp-waitlist__eyebrow', 'Restock alerts'));
    card.appendChild(el('h2', 'rarely-lp-waitlist__title', title));
    card.appendChild(el('p', 'rarely-lp-waitlist__copy', copy));
    section.appendChild(card);
    return { section: section, card: card };
  }

  function createSingleCard(product) {
    var variants = waitlistVariants(product);
    var shell = cardShell(
      'Want it when it’s back?',
      'Choose the one you want and we’ll send you one email when it returns.'
    );
    shell.section.dataset.productHandle = product.handle;
    var formBlock = createNotifyForm(product, variants);
    shell.card.appendChild(formBlock);
    document.addEventListener('rarely:demand:variant-change', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (String(detail.productId || '') !== String(product.id)) return;
      var selectedVariant = product.variants.find(function (variant) {
        return String(variant.id) === String(detail.variantId || '');
      });
      if (!selectedVariant) return;
      var waitlistable = !selectedVariant.available || selectedVariant.preorder;
      shell.section.hidden = !waitlistable;
      if (!waitlistable) return;
      var notify = formBlock.querySelector('demand-notify-form');
      var select = formBlock.querySelector('.rarely-lp-waitlist__select');
      if (notify) notify.dataset.variantId = String(selectedVariant.id);
      if (select) select.value = String(selectedVariant.id);
    });
    return shell.section;
  }

  function createMultiCard(products) {
    var shell = cardShell(
      'Waiting on something?',
      'Pick the item you want and we’ll let you know when it returns.'
    );
    shell.section.classList.add('rarely-lp-waitlist--fallback');
    var field = el('div', 'rarely-lp-waitlist__field');
    var productSelectId = 'rarely-lp-waitlist-product-' + (++uid);
    addFieldLabel(field, 'Choose a product', productSelectId);
    var select = el('select', 'rarely-lp-waitlist__select');
    select.id = productSelectId;
    products.forEach(function (product) {
      var option = document.createElement('option');
      option.value = product.handle;
      option.textContent = product.title;
      select.appendChild(option);
    });
    field.appendChild(select);
    shell.card.appendChild(field);
    var slot = el('div', 'rarely-lp-waitlist__product-slot');
    shell.card.appendChild(slot);

    function renderSelected() {
      var product = products.find(function (item) { return item.handle === select.value; }) || products[0];
      while (slot.firstChild) slot.removeChild(slot.firstChild);
      slot.appendChild(createNotifyForm(product, waitlistVariants(product)));
    }
    select.addEventListener('change', renderSelected);
    renderSelected();
    return shell.section;
  }

  function entryTitle(entry) {
    if (entry.title) return String(entry.title);
    var links = document.querySelectorAll('a[href*="/products/' + entry.handle + '"]');
    for (var i = 0; i < links.length; i += 1) {
      var text = (links[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (text) return text;
    }
    return String(entry.handle).replace(/-/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function createLazyMultiCard(entries) {
    var shell = cardShell(
      'Waiting on something?',
      'Pick the item you want. We’ll check it and, if it’s sold out, let you join its restock list.'
    );
    shell.section.classList.add('rarely-lp-waitlist--fallback');
    var field = el('div', 'rarely-lp-waitlist__field');
    var productSelectId = 'rarely-lp-waitlist-product-' + (++uid);
    addFieldLabel(field, 'Choose a product', productSelectId);
    var select = el('select', 'rarely-lp-waitlist__select');
    select.id = productSelectId;
    entries.forEach(function (entry) {
      var option = document.createElement('option');
      option.value = entry.handle;
      option.textContent = entryTitle(entry);
      select.appendChild(option);
    });
    field.appendChild(select);
    shell.card.appendChild(field);
    var slot = el('div', 'rarely-lp-waitlist__product-slot');
    shell.card.appendChild(slot);
    var renderToken = 0;

    function renderSelected() {
      renderToken += 1;
      var token = renderToken;
      var entry = entries.find(function (item) { return item.handle === select.value; }) || entries[0];
      while (slot.firstChild) slot.removeChild(slot.firstChild);
      slot.appendChild(el('p', 'rarely-lp-waitlist__availability', 'Checking availability…'));
      hydrateProduct(entry).then(function (product) {
        if (token !== renderToken) return;
        while (slot.firstChild) slot.removeChild(slot.firstChild);
        if (!product) {
          slot.appendChild(el('p', 'rarely-lp-waitlist__availability', 'We couldn’t check this item. Please try its product page.'));
          return;
        }
        var variants = waitlistVariants(product);
        if (!variants.length) {
          slot.appendChild(el('p', 'rarely-lp-waitlist__availability', 'This item is currently in stock.'));
          return;
        }
        slot.appendChild(createNotifyForm(product, variants));
      });
    }

    select.addEventListener('change', renderSelected);
    renderSelected();
    return shell.section;
  }

  function isVisible(node) {
    if (!node || !node.isConnected) return false;
    var style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function explicitAnchor(product) {
    var nodes = document.querySelectorAll('[data-rarely-waitlist-anchor]');
    for (var i = 0; i < nodes.length; i += 1) {
      var requested = nodes[i].getAttribute('data-product-handle');
      if (!requested || requested === product.handle) return nodes[i];
    }
    return null;
  }

  function candidateFor(product) {
    var anchor = explicitAnchor(product);
    if (anchor) return { node: anchor, explicit: true };
    var nodes = document.querySelectorAll('button, a, [role="button"]');
    var variantIds = waitlistVariants(product).map(function (variant) { return String(variant.id); });
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.closest('.rarely-lp-waitlist') || !isVisible(node)) continue;
      var text = (node.textContent || '').trim();
      if (!SOLD_OUT_RE.test(text)) continue;
      var context = node.closest('[data-product-handle], [data-product-id], form, article, section, li, div') || node;
      var html = (node.getAttribute('href') || '') + ' ' + (context.getAttribute('data-product-handle') || '') + ' ' + (context.getAttribute('data-variant-id') || '');
      var matched = html.indexOf(product.handle) !== -1 || variantIds.some(function (id) { return html.indexOf(id) !== -1; });
      if (matched) return { node: node, explicit: false };
    }
    for (var j = 0; j < nodes.length; j += 1) {
      var fallback = nodes[j];
      if (!fallback.closest('.rarely-lp-waitlist') && isVisible(fallback) && SOLD_OUT_RE.test((fallback.textContent || '').trim())) {
        return { node: fallback, explicit: false };
      }
    }
    return null;
  }

  function fallbackParent() {
    return document.querySelector('main') || document.body;
  }

  function placeSingle(section, product) {
    var target = candidateFor(product);
    if (target) {
      if (target.explicit) target.node.appendChild(section);
      else target.node.insertAdjacentElement('afterend', section);
      section.classList.remove('rarely-lp-waitlist--fallback');
      section.dataset.placement = 'inline';
      return true;
    }
    section.classList.add('rarely-lp-waitlist--fallback');
    section.dataset.placement = 'fallback';
    fallbackParent().appendChild(section);
    return false;
  }

  function boot() {
    var entries = parseRegistries();
    if (!entries.length) return;

    var unresolved = entries.filter(function (entry) { return !normalizeProduct(entry); });
    if (entries.length > 6 && unresolved.length) {
      fallbackParent().appendChild(createLazyMultiCard(entries));
      return;
    }

    Promise.all(entries.map(hydrateProduct)).then(function (products) {
      var eligible = products.filter(Boolean).filter(function (product) {
        return waitlistVariants(product).length > 0;
      });
      if (!eligible.length) return;

      if (eligible.length === 1) {
        var section = createSingleCard(eligible[0]);
        var placed = placeSingle(section, eligible[0]);
        if (!placed && window.MutationObserver) {
          var queued = false;
          var observer = new MutationObserver(function () {
            if (queued || section.dataset.placement === 'inline') return;
            queued = true;
            window.requestAnimationFrame(function () {
              queued = false;
              if (candidateFor(eligible[0])) {
                placeSingle(section, eligible[0]);
                observer.disconnect();
              }
            });
          });
          observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
          window.setTimeout(function () { observer.disconnect(); }, 15000);
        }
      } else {
        fallbackParent().appendChild(createMultiCard(eligible));
      }
    });
  }

  ready(boot);
})();
